import {
  IDefaultValues,
  IFiveYearValues,
  INavPrice,
  IThreeYearValues,
  IPriceCart,
  IStickyCartProductDetails,
} from '../../Cart/StickyCartTypes'

//Gets the values for the first load of the page.
export const handleDefault = (
  type?: string,
  yearTermCurrent?: string,
  priceToggleBlock?: boolean,
  dropDownYearTermBlock?: boolean,
  useMobilityCoupons?: boolean,
  defaultValues?: IDefaultValues,
  fiveYearValues?: IFiveYearValues,
  threeYearValues?: IThreeYearValues,
  cartPrice?: IPriceCart,
  navPrice?: INavPrice
) => {
  let values = {
    url: '',
    ribbonText: '',
    price: '',
    strikePrice: '',
  }

  //Check if there's price toggle in the component
  if (priceToggleBlock) {
    //If there's a pricetoggle then checks if there's a dropdown in the component
    if (dropDownYearTermBlock) {
      //If there's a dropdown we need to assign the following values: url, ribbon text, price and strike price
      values = getValuesYearTerm(
        type,
        yearTermCurrent,
        useMobilityCoupons,
        fiveYearValues,
        threeYearValues,
        cartPrice,
        navPrice
      )
    } else {
      //Get the values with priceToggle and without the dropdown.
      values = getValuesPriceToggle(type, useMobilityCoupons, defaultValues, cartPrice, navPrice)
    }
  } else {
    //If there's not pricetoggle return the default values
    values.url = defaultValues.primaryButtonHrefWithToggleOff
    values.ribbonText = defaultValues.ribbonTextWithToggleOff
    type === 'cart'
      ? ((values.price = cartPrice.priceWithToggleOff), (values.strikePrice = cartPrice.strikePriceWithToggleOff))
      : ((values.price = navPrice.priceWithToggleOff), (values.strikePrice = undefined))
  }

  return values
}

//Gets the values when the dropdown value change.
export const handleSelectDropdown = (
  type?: string,
  yearTermCurrentCurrent?: string,
  useMobilityCouponsLocal?: boolean,
  defaultValues?: IDefaultValues,
  fiveYearValues?: IFiveYearValues,
  threeYearValues?: IThreeYearValues,
  cartPrice?: IPriceCart,
  navPrice?: INavPrice
) => {
  //Gets the yearTerm from localStorage and changes the value for the opposite one.
  const yearValue = yearTermCurrentCurrent

  //Get values from function getValuesYearTerm()
  const values = getValuesYearTerm(
    type,
    yearValue,
    useMobilityCouponsLocal,
    fiveYearValues,
    threeYearValues,
    cartPrice,
    navPrice
  )

  //Assign values for the return.
  const url = values.url
  const ribbonText = values.ribbonText
  const price = values.price
  const strikePrice = values.strikePrice

  return { yearValue, url, ribbonText, price, strikePrice }
}

//Gets the values when the priceToggle value change.
export const handlePriceToggle = (
  type?: string,
  useMobilityCouponsLocal?: boolean,
  yearTermLocal?: string,
  defaultValues?: IDefaultValues,
  fiveYearValues?: IFiveYearValues,
  threeYearValues?: IThreeYearValues,
  cartPrice?: IPriceCart,
  dropDownYearTermBlock?: boolean,
  navPrice?: INavPrice
) => {
  let offOnState: boolean = useMobilityCouponsLocal
  offOnState = !offOnState
  let values

  //Check if there's dropdown
  if (dropDownYearTermBlock) {
    //If there's dropdown in the component calls the getValuesYearTerm() function
    values = getValuesYearTerm(type, yearTermLocal, offOnState, fiveYearValues, threeYearValues, cartPrice, navPrice)
  } else {
    //If there's no dropdown in the component calls the getValuesPriceToggle() function
    values = getValuesPriceToggle(type, offOnState, defaultValues, cartPrice, navPrice)
  }

  //Assign values for the return.
  const url: string = values.url
  const ribbonText: string = values.ribbonText
  const price: string = values.price
  const strikePrice: string = values.strikePrice

  return { offOnState, url, ribbonText, price, strikePrice }
}

const getValuesYearTerm = (
  type,
  yearTermCurrent,
  useMobilityCoupons,
  fiveYearValues: IFiveYearValues,
  threeYearValues: IThreeYearValues,
  cartPrice: IPriceCart,
  navPrice: INavPrice
) => {
  let url: string
  let ribbonText: string
  let price: string
  let strikePrice: string
  let yearTerm: {
    primaryButtonHrefFiveYearWithToggleOn: string
    ribbonTextFiveYearTermToggleOn: string
    primaryButtonHrefFiveYearWithToggleOff: string
    ribbonTextFiveYearTermToggleOff: string
  }
  //Get the values from fiveYearValues
  const fiveYearTerm = {
    primaryButtonHrefFiveYearWithToggleOn: fiveYearValues.primaryButtonHrefFiveYearWithToggleOn,
    primaryButtonHrefFiveYearWithToggleOff: fiveYearValues.primaryButtonHrefFiveYearWithToggleOff,
    ribbonTextFiveYearTermToggleOn: fiveYearValues.ribbonTextFiveYearTermToggleOn,
    ribbonTextFiveYearTermToggleOff: fiveYearValues.ribbonTextFiveYearTermToggleOff,
  }
  //Get the values from threeYearValues
  const threeYearTerm = {
    primaryButtonHrefFiveYearWithToggleOn: threeYearValues.primaryButtonHrefThreeYearWithToggleOn,
    primaryButtonHrefFiveYearWithToggleOff: threeYearValues.primaryButtonHrefThreeYearWithToggleOff,
    ribbonTextFiveYearTermToggleOn: threeYearValues.ribbonTextThreeYearTermToggleOn,
    ribbonTextFiveYearTermToggleOff: threeYearValues.ribbonTextThreeYearTermToggleOff,
  }

  yearTermCurrent === '5-year' ? (yearTerm = fiveYearTerm) : (yearTerm = threeYearTerm)

  //Check if priceToggle is true or false and sets values
  if (useMobilityCoupons) {
    url = yearTerm.primaryButtonHrefFiveYearWithToggleOn
    ribbonText = yearTerm.ribbonTextFiveYearTermToggleOn
    //Check current yearTerm
    if (yearTermCurrent === '5-year') {
      //Check if it's for nav or cart component to set price and strikePrice (note: nav doesn't need strike price)
      type === 'cart'
        ? ((price = cartPrice.priceFiveYearWithToggleOn), (strikePrice = cartPrice.strikePriceFiveYearWithToggleOn))
        : ((price = navPrice.priceFiveYearWithToggleOn), (strikePrice = undefined))
    } else {
      //Check if it's for nav or cart component to set price and strikePrice (note: nav doesn't need strike price)
      type === 'cart'
        ? ((price = cartPrice.priceThreeYearWithToggleOn), (strikePrice = cartPrice.strikePriceThreeYearWithToggleOn))
        : ((price = navPrice.priceThreeYearWithToggleOn), (strikePrice = undefined))
    }
  } else {
    url = yearTerm.primaryButtonHrefFiveYearWithToggleOff
    ribbonText = yearTerm.ribbonTextFiveYearTermToggleOff
    //Check current yearTerm
    if (yearTermCurrent === '5-year') {
      //Check if it's for nav or cart component to set price and strikePrice (note: nav doesn't need strike price)
      type === 'cart'
        ? ((price = cartPrice.priceFiveYearWithToggleOff), (strikePrice = cartPrice.strikePriceFiveYearWithToggleOff))
        : ((price = navPrice.priceFiveYearWithToggleOff), (strikePrice = undefined))
    } else {
      //Check if it's for nav or cart component to set price and strikePrice (note: nav doesn't need strike price)
      type === 'cart'
        ? ((price = cartPrice.priceThreeYearWithToggleOff), (strikePrice = cartPrice.strikePriceThreeYearWithToggleOff))
        : ((price = navPrice.priceThreeYearWithToggleOff), (strikePrice = undefined))
    }
  }

  return { url, ribbonText, price, strikePrice }
}

const getValuesPriceToggle = (
  type,
  useMobilityCoupons,
  defaultValues: IDefaultValues,
  cartPrice: IPriceCart,
  navPrice: INavPrice
) => {
  let url: string
  let ribbonText: string
  let price: string
  let strikePrice: string

  //Check if priceToggle is true or false and sets values
  if (useMobilityCoupons) {
    url = defaultValues.primaryButtonHrefWithToggleOn
    ribbonText = defaultValues.ribbonTextWithToggleOn
    //Check if it's for nav or cart component to set price and strikePrice (note: nav doesn't need strike price)
    type === 'cart'
      ? ((price = cartPrice.priceWithToggleOn), (strikePrice = cartPrice.strikePriceWithToggleOn))
      : ((price = navPrice.priceWithToggleOn), (strikePrice = undefined))
  } else {
    url = defaultValues.primaryButtonHrefWithToggleOff
    ribbonText = defaultValues.ribbonTextWithToggleOff
    //Check if it's for nav or cart component to set price and strikePrice (note: nav doesn't need strike price)
    type === 'cart'
      ? ((price = cartPrice.priceWithToggleOff), (strikePrice = cartPrice.strikePriceWithToggleOff))
      : ((price = navPrice.priceWithToggleOff), (strikePrice = undefined))
  }

  return { url, ribbonText, price, strikePrice }
}

//Values for productsDetails
export const handleProductName = (
  priceToggleBlock,
  dropDownYearTermBlock,
  useMobilityCoupons: boolean,
  yearTermCurrent: string,
  product: IStickyCartProductDetails
) => {
  //Get the value when there's a dropdown
  let name: string
  if (priceToggleBlock) {
    if (dropDownYearTermBlock) {
      if (useMobilityCoupons) {
        yearTermCurrent === '5-year'
          ? (name = product.productNameFiveYearTermToggleOn)
          : (name = product.productNameThreeYearTermToggleOn)
      } else {
        yearTermCurrent === '5-year'
          ? (name = product.productNameFiveYearTermToggleOff)
          : (name = product.productNameThreeYearTermToggleOff)
      }
    } else {
      //Get the value without dropdown
      useMobilityCoupons ? (name = product.productNameWithCoupon) : (name = product.productName)
    }
  } else {
    //Get the value without dropdown or pricetoggle
    name = product.productName
  }

  return name
}

const getPriceYearTerm = (useMobilityCoupons, yearTermCurrent, product, cartPrice) => {
  let price: string

  //Get value with toggle ON and 5-year term
  if (useMobilityCoupons) {
    if (yearTermCurrent === '5-year') {
      if (product.productPriceFiveYearTermToggleOn) {
        cartPrice.stickyCartPriceSignDirection === 'left'
          ? (price = '$' + product.productPriceFiveYearTermToggleOn)
          : (price = product.productPriceFiveYearTermToggleOn + '$')
      } else {
        price = product.productPriceTextFiveYearTermToggleOn
      }
    } else {
      //Get value with toggle ON ad 3-year term
      if (product.productPriceThreeYearTermToggleOn) {
        cartPrice.stickyCartPriceSignDirection === 'left'
          ? (price = '$' + product.productPriceThreeYearTermToggleOn)
          : (price = product.productPriceThreeYearTermToggleOn + '$')
      } else {
        price = product.productPriceTextThreeYearTermToggleOn
      }
    }
    //Get value with toggle OFF and 5-year term
  } else {
    if (yearTermCurrent === '5-year') {
      if (product.productPriceFiveYearTermToggleOff) {
        cartPrice.stickyCartPriceSignDirection === 'left'
          ? (price = '$' + product.productPriceFiveYearTermToggleOff)
          : (price = product.productPriceFiveYearTermToggleOff + '$')
      } else {
        price = product.productPriceTextFiveYearTermToggleOff
      }
    } else {
      //Get value with toggle OFF and 3-year term
      if (product.productPriceThreeYearTermToggleOff) {
        cartPrice.stickyCartPriceSignDirection === 'left'
          ? (price = '$' + product.productPriceThreeYearTermToggleOff)
          : (price = product.productPriceThreeYearTermToggleOff + '$')
      } else {
        price = product.productPriceTextThreeYearTermToggleOff
      }
    }
  }

  return price
}

//Get the price of the product
export const handleProductPrice = (
  priceToggleBlock,
  dropDownYearTermBlock,
  useMobilityCoupons: boolean,
  yearTermCurrent: string,
  product: IStickyCartProductDetails,
  cartPrice: IPriceCart
) => {
  let price: string

  //Check if there's a pricetoggle
  if (priceToggleBlock) {
    //Checks if there's a dropdown in the component
    if (dropDownYearTermBlock) {
      //Price depends on year-term
      price = getPriceYearTerm(useMobilityCoupons, yearTermCurrent, product, cartPrice)
    } else {
      //Get the price without the dropdown
      if (useMobilityCoupons) {
        if (product.productCouponPrice) {
          cartPrice.stickyCartPriceSignDirection === 'left'
            ? (price = '$' + product.productCouponPrice)
            : (price = product.productCouponPrice + '$')
        } else {
          price = product.productCouponPriceText
        }
      } else {
        if (product.productPrice) {
          cartPrice.stickyCartPriceSignDirection === 'left'
            ? (price = '$' + product.productPrice)
            : (price = product.productPrice + '$')
        } else {
          price = product.productCouponPriceText
        }
      }
    }
  } else {
    //Get the price without pricetoggle or dropdown
    if (product.productPrice) {
      cartPrice.stickyCartPriceSignDirection === 'left'
        ? (price = '$' + product.productPrice)
        : (price = product.productPrice + '$')
    } else {
      price = product.productPriceText
    }
  }

  return price
}
